import { isEqual } from 'lodash';
import { Box, Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { PlusPersonIcon, TrashIcon } from 'Asset/icon';
import { TextRegular } from 'UiKit/typography';
import { Condition, Iteration } from 'Component/others';
import useGetRulesetDetail from 'Domain/schedule-generate/useGetRulesetDetail';
import { useToast } from 'Store/toast';

import { useScheduleGenerateState } from 'View/schedule-generate/state';

import styles from './styles.module.css';
import deleteHostSchedule from 'View/schedule-generate/helper/deleteHostSchedule';
import addHostSchedule from 'View/schedule-generate/helper/addHostSchedule';
import { getPeriodWeek } from 'View/schedule-generate/helper/getPeriodDay';

const PopoverHandleHost = ({ isOpen, onClose, children }) => {
  const { t } = useTranslation('schedule-generate');
  const { onOpenToast } = useToast();
  const { handleHost, updateState, accounts, selectedTab, formData, generateResultData, popupLocation } = useScheduleGenerateState();
  const { data: rulesetDetail } = useGetRulesetDetail({ rulesetId: formData?.rulesetId });
  const accountIndex = accounts.findIndex((account) => account.type === selectedTab);
  const currentAccount = accounts[accountIndex];
  const { datas } = currentAccount;
  const showWeek = getPeriodWeek(popupLocation?.[0], formData?.yearMonth);
  const weekIndex = datas?.findIndex((data) => data.week === showWeek);
  const locationSchedules = datas[weekIndex]?.schedules.filter((schedule) => isEqual(schedule.location, popupLocation)) || [];

  const handleDeleteHost = () => {
    deleteHostSchedule({ accounts, accountIndex, weekIndex, handleHost, updateState });
    onClose();
  };

  const handleAddHost = (selectedHost) => {
    addHostSchedule({
      selectedHost,
      locationSchedules,
      onOpenToast,
      yearMonth: generateResultData?.metadata?.yearMonth,
      popupLocation,
      accounts,
      accountIndex,
      weekIndex,
      updateState,
      t,
    });
    onClose();
  };

  return (
    <Popover returnFocusOnClose={false} isOpen={isOpen} onClose={onClose} placement="right" closeOnBlur={true} isLazy>
      <PopoverAnchor>{children}</PopoverAnchor>
      <PopoverContent className={styles['popover__content']}>
        <Condition statement={handleHost !== null}>
          <Box className={styles['popover__box--delete']} onClick={handleDeleteHost}>
            <TrashIcon width="12px" height="12px" color="var(--color-error50)" />
            <TextRegular className={styles['popover__text--delete']}>{t('popoverDeleteHost')}</TextRegular>
          </Box>
        </Condition>
        <Condition statement={locationSchedules.length < 3}>
          <Popover placement="right">
            <PopoverTrigger>
              <Box className={styles['popover__box--add']}>
                <PlusPersonIcon width="12px" height="12px" color="var(--color-semantic-text)" />
                <TextRegular className={styles['popover__text--add']}>{t('popoverAddHost')}</TextRegular>
              </Box>
            </PopoverTrigger>
            <PopoverContent className={styles['popover-hosts__content']}>
              <Box>
                <Iteration
                  items={rulesetDetail?.users || []}
                  render={(host) => {
                    return (
                      <Box key={host.userId} className={styles['host-option__box']} onClick={() => handleAddHost(host)}>
                        <TextRegular className={styles['host-option__text']}>{host.name}</TextRegular>
                      </Box>
                    );
                  }}
                />
              </Box>
            </PopoverContent>
          </Popover>
        </Condition>
      </PopoverContent>
    </Popover>
  );
};

export default PopoverHandleHost;
